export function normalizeSearchFieldsConfig(searchFieldOptions = []) {
  return (searchFieldOptions || []).map((s) =>
    typeof s === 'string'
      ? { value: s, label: s }
      : { value: s.value, label: s.label, tableName: s.tableName, fieldName: s.fieldName, joinKey: s.joinKey }
  );
}

export function buildAllColumnFilters({ q = '', searchFieldsConfig = [] } = {}) {
  const value = String(q ?? '').trim();
  if (!value) return [];
  const filters = [];
  (searchFieldsConfig || []).forEach((cfg) => {
    if (!cfg || String(cfg.value) === 'all') return;
    if (cfg.tableName) {
      filters.push({ name: cfg.fieldName ?? 'name', table_name: cfg.tableName, value });
    } else if (cfg.fieldName && !cfg.tableName) {
      filters.push({ name: cfg.fieldName, value });
    } else {
      filters.push({ name: cfg.value, value });
    }
  });
  return filters;
}

export function getJoinsForFields({ searchFieldsConfig = [], joinDefs = {}, extraJoins = [] } = {}) {
  const uniq = new Set();
  const joins = [];
  (searchFieldsConfig || []).forEach((cfg) => {
    if (!cfg || String(cfg.value) === 'all') return;
    const key = cfg.joinKey ?? cfg.value;
    const def = joinDefs?.[key];
    if (def && !uniq.has(def.name)) {
      joins.push(def);
      uniq.add(def.name);
    } else if (cfg.tableName) {
      const name = cfg.tableName;
      if (!uniq.has(name)) {
        joins.push({ name, column_results: [cfg.fieldName ?? 'name'] });
        uniq.add(name);
      }
    }
  });
  (extraJoins || []).forEach((j) => {
    if (!j || !j.name) return;
    if (!uniq.has(j.name)) {
      joins.push(j);
      uniq.add(j.name);
    }
  });
  return joins;
}

export function getSearchColumnsForAll({ searchFieldsConfig = [], companyFilterColumns = [] } = {}) {
  const cols = [];
  (searchFieldsConfig || [])
    .filter((cfg) => cfg && String(cfg.value) !== 'all')
    .forEach((cfg) => {
      if (cfg.tableName) {
        cols.push({ table_name: cfg.tableName, name: cfg.fieldName ?? 'name', logic_operator: 'like', operator: 'AND', value: '' });
      } else if (cfg.fieldName && !cfg.tableName) {
        cols.push({ name: cfg.fieldName, logic_operator: 'like', operator: 'AND', value: '' });
      } else {
        cols.push({ name: cfg.value, logic_operator: 'like', operator: 'AND', value: '' });
      }
    });

  const seen = new Set();
  const out = [];

  companyFilterColumns = Array.isArray(companyFilterColumns) ? companyFilterColumns : [];
  companyFilterColumns.forEach((c) => {
    const key = `${c.table_name || ''}:${c.name || ''}:${c.value || ''}`;
    if (!seen.has(key)) {
      out.push(c);
      seen.add(key);
    }
  });

  cols.forEach((c) => {
    const key = `${c.table_name || ''}:${c.name || ''}:${c.value || ''}`;
    if (!seen.has(key)) {
      out.push(c);
      seen.add(key);
    }
  });

  return out;
}

export function buildAllSearchPayload({
  q = '',
  searchFieldsConfig = [],
  joinDefs = {},
  companyFilterColumns = [],
  paging = { start: 0, length: 10 },
  orders = { columns: ['id'], ascending: false },
  extraJoins = []
} = {}) {
  const joins = getJoinsForFields({ searchFieldsConfig, joinDefs, extraJoins });
  const filters = buildAllColumnFilters({ q, searchFieldsConfig });
  const columns = getSearchColumnsForAll({ searchFieldsConfig, companyFilterColumns });
  return {
    columns,
    customFilter: '',
    customJoin: '',
    filters,
    joins,
    orders,
    paging
  };
}
